import { WALLET_TYPES, FinancialInstituitionName } from '~/types'

export type WalletIdType =
  | WALLET_TYPES.DIGITAL_GOODS
  | WALLET_TYPES.GENERAL
  | WALLET_TYPES.TEMPORARY_HOLDING_BALANCE
  | undefined

export type UserDetails = {
  fullName: string
  bankAccounts: BankAccount[]
  blockchainAddresses: BlockchainAddress[]
  accountFullyVerified: boolean
  kycInfoVerifying: boolean
  kycRejectReason: Record<string, string>
}

export type BankAccount = {
  id: number
  bankName: string
  accountNumber: string
  status: string
}

export type BlockchainAddress = {
  address: string
  approved: boolean | null
  blockchain: string
  financialInstitutionId: number
  nickname: string
}

export type BankIconDetails = {
  name: string
  abbreviation: string
  bank_code: string
  img_src: string
  swift_code: string
}

export type FinancialInstituition = {
  id: number
  name: FinancialInstituitionName
  enabled: boolean
}

export type Account = {
  attributes: {
    wallet_id: number
    limitations: {}
    type: string
  }
}

export type Wallet = {
  type: WalletIdType
  balance: string
  formattedBalance: string
  label: string
  accountId: number
  accountType: string
  fundPoolId: number
}

export enum MY_ACCOUNT_ACTIONS {
  GET_USER_DETAILS = 'MY_ACCOUNT_ACTIONS.GET_USER_DETAILS',
  GET_STABLECOIN_DATA = 'MY_ACCOUNT_ACTIONS.GET_STABLECOIN_DATA',
  GET_BANK_ICONS = 'MY_ACCOUNT_ACTIONS.GET_BANK_ICONS',
  SET_IS_USER_DETAIL_LOADING = 'MY_ACCOUNT_ACTIONS.SET_IS_USER_DETAIL_LOADING',
  DELETE_BANK_ACCOUNTS = 'MY_ACCOUNT_ACTIONS.DELETE_BANK_ACCOUNT',
  DELETE_BLOCKCHAIN_ADDRESS = 'MY_ACCOUNT_ACTIONS.DELETE_BLOCKCHAIN_ADDRESS',
  SET_DIGITAL_GOODS_USER = 'MY_ACCOUNT_ACTIONS.SET_DIGITAL_GOODS_USER',
  GET_WALLETS = 'MY_ACCOUNT_ACTIONS.GET_WALLETS',
}

type GetUserDetails = {
  type: typeof MY_ACCOUNT_ACTIONS.GET_USER_DETAILS
  userDetails: UserDetails
  hasDigitalGoodsAccounts: boolean
}

type GetStablecoinData = {
  type: typeof MY_ACCOUNT_ACTIONS.GET_STABLECOIN_DATA
  blockchainAddresses: BlockchainAddress[]
  fiList: FinancialInstituition[]
  addressQuota: number
}

type GetBankIcons = {
  type: typeof MY_ACCOUNT_ACTIONS.GET_BANK_ICONS
  bankIcons: BankIconDetails[]
}

type DeleteBankAccount = {
  type: typeof MY_ACCOUNT_ACTIONS.DELETE_BANK_ACCOUNTS
  bankAccounts: BankAccount[]
}

type DeleteBlockchainAddress = {
  type: typeof MY_ACCOUNT_ACTIONS.DELETE_BLOCKCHAIN_ADDRESS
  blockchainAddresses: BlockchainAddress[]
  addressQuota: number
}

type SetIsUserDetailLoading = {
  type: typeof MY_ACCOUNT_ACTIONS.SET_IS_USER_DETAIL_LOADING
  isUserDetailLoading: boolean
}

type GetWallets = {
  type: typeof MY_ACCOUNT_ACTIONS.GET_WALLETS
  wallets: Wallet[]
}

export type ActionTypes =
  | GetUserDetails
  | GetStablecoinData
  | GetBankIcons
  | DeleteBankAccount
  | SetIsUserDetailLoading
  | DeleteBlockchainAddress
  | GetWallets
